// ── OpportunityClaudePanel (Evo Brain) ───────────────────────────────────────
// No renderiza UI propia: el shell genérico vive en AssistantDock (ver
// contexts/AssistantContext.tsx). Esto solo registra qué carta está abierta,
// para que Evo Brain sepa de cuál le están hablando.

import { useTranslation } from 'react-i18next';
import { useAssistantModule, useRegisterAssistantActive } from '../../contexts/AssistantContext.js';
import { useOpportunity } from '../../hooks/useFunnels.js';

interface Props {
  /** La carta abierta en el panel derecho. null = ninguna. */
  opportunityId: number | null;
  funnelId: number | null;
}

export function OpportunityClaudePanel({ opportunityId, funnelId }: Props) {
  const { t } = useTranslation();
  const { data } = useOpportunity(opportunityId);
  const id = opportunityId != null ? String(opportunityId) : null;

  useAssistantModule('opportunity', id, undefined);

  useRegisterAssistantActive('opportunity', id, {
    title: t('opportunities.assistant.title'),
    placeholder: opportunityId ? t('opportunities.assistant.placeholder') : t('opportunities.assistant.placeholderDisabled'),
    inputDisabled: !opportunityId,
    emptyHint: t('opportunities.assistant.empty'),
    entityLink: data?.opportunity && funnelId != null
      ? { label: data.opportunity.title, href: `/embudos/${funnelId}` }
      : null,
  });

  return null;
}
